import { useQuery, UseQueryOptions } from 'react-query';

import { pricingService } from 'parts/services';

export const useGetPartPricingMultiplier = (
  criteria,
  options: UseQueryOptions<any, unknown, any, any[]> = { enabled: false }
) => {
  const { data, isError, isLoading } = useQuery(
    ['partPricingMultiplier', criteria],
    ({ signal }) => pricingService.getPartPricingMultiplier(criteria, signal),
    {
      keepPreviousData: true,
      ...options,
    }
  );

  return {
    pricingMultiplier: data?.record ?? null,
    isError,
    isLoading,
  };
};
